

export default {
name: 'logoutAgreement',
components: {

},
data () {
return {

}
},
methods: {

},
created () {

},
mounted() {

},
}



// WEBPACK FOOTER //
// ./src/views/logoutAgreement/script.js